import { APP_STORE_URL, PLAY_STORE_URL } from '../../lib/shareTokens'

/** Official App Store / Google Play badge linking to the Stazon listing. */
export default function StoreBadge({ platform, height = 48 }: { platform: 'ios' | 'android'; height?: number }) {
  const isIos = platform === 'ios'
  return (
    <a
      href={isIos ? APP_STORE_URL : PLAY_STORE_URL}
      style={{ display: 'block', textDecoration: 'none', flexShrink: 0 }}
    >
      <img
        src={isIos ? '/badge-appstore.svg' : '/badge-playstore.png'}
        alt={isIos ? 'Download on the App Store' : 'Get it on Google Play'}
        style={{ height, width: 'auto', display: 'block' }}
      />
    </a>
  )
}
